module.exports = __webpack_public_path__ + "static/portfolio-stamp-79619b21e6cc18975790d7b3f553eeb0.jpg";